import {
  LOGIN_REQUEST_PENDING,
  LOGIN_REQUEST_SUCCESS,
  LOGIN_REQUEST_FAILED,
  SIGNUP_REQUEST_PENDING,
  SIGNUP_REQUEST_SUCCESS,
  SIGNUP_REQUEST_FAILED,
  RESET_EMAIL_INPUT_PENDING,
  RESET_EMAIL_INPUT_SUCCESS,
  RESET_EMAIL_INPUT_FAILED,
  TOKEN_INPUT_PENDING,
  TOKEN_INPUT_SUCCESS,
  TOKEN_INPUT_FAILED,
  RESET_PASSWORD_INPUT_PENDING,
  RESET_PASSWORD_INPUT_SUCCESS,
  RESET_PASSWORD_INPUT_FAILED,
  DISPLAY_RESET_EMAIL,
  DISPLAY_TOKEN,
  DISPLAY_RESET_PASSWORD,
  SET_USER,
  LOGOUT,
  SET_TOKEN,
  RESET_APP
} from "./mutations/app";
import {
  sendLoginRequest,
  sendSignupRequest,
  sendTokenRequest,
  sendTokenValidationRequest,
  sendNewPasswordRequest,
  validateLoginToken
} from "../requests";

export const AuthState = {
  AUTHENTICATED: "AUTHENTICATED",
  UNAUTHENTICATED: "UNAUTHENTICATED",
  AUTHENTICATION_PENDING: "AUTHENTICATION_PENDING",
  AUTHENTICATION_FAILURE: "AUTHENTICATION_FAILURE"
};

export const PasswordResetRequestState = {
  EMAIL_INPUT: {
    PENDING: RESET_EMAIL_INPUT_PENDING,
    SUCCESS: RESET_EMAIL_INPUT_SUCCESS,
    FAILED: RESET_EMAIL_INPUT_FAILED
  },
  TOKEN_INPUT: {
    PENDING: TOKEN_INPUT_PENDING,
    SUCCESS: TOKEN_INPUT_SUCCESS,
    FAILED: TOKEN_INPUT_FAILED
  },
  PASSWORD_INPUT: {
    PENDING: RESET_PASSWORD_INPUT_PENDING,
    SUCCESS: RESET_PASSWORD_INPUT_SUCCESS,
    FAILED: RESET_PASSWORD_INPUT_FAILED
  }
};

export const PasswordResetDisplayState = {
  EMAIL: "EMAIL",
  TOKEN: "TOKEN",
  PASSWORD: "PASSWORD"
};

export default {
  namespaced: true,
  state: {
    authStatus: AuthState.UNAUTHENTICATED,
    passwordResetStatus: PasswordResetRequestState.EMAIL_INPUT.RESET_EMAIL_INPUT_FAILED,
    passwordResetDisplayStatus: PasswordResetDisplayState.EMAIL,
    loginErrorMessage: "",
    signupErrorMessage: "",
    token: window.localStorage.getItem("token") || "",
    resetToken: "",
    user: {
      email: window.localStorage.getItem("email") || "",
      dealerName: window.localStorage.getItem("dealerName") || ""
    }
  },
  mutations: {
    [LOGIN_REQUEST_PENDING](state) {
      state.authStatus = AuthState.AUTHENTICATION_PENDING;
    },
    [LOGIN_REQUEST_SUCCESS](state) {
      state.authStatus = AuthState.AUTHENTICATED;
      state.loginErrorMessage = "";
    },
    [LOGIN_REQUEST_FAILED](state, { errorMessage }) {
      state.authStatus = AuthState.AUTHENTICATION_FAILURE;
      state.loginErrorMessage = `*${errorMessage}`;
    },
    [SIGNUP_REQUEST_PENDING](state) {
      state.authStatus = AuthState.AUTHENTICATION_PENDING;
    },
    [SIGNUP_REQUEST_SUCCESS](state) {
      state.authStatus = AuthState.AUTHENTICATED;
      state.signupErrorMessage = "";
    },
    [SIGNUP_REQUEST_FAILED](state, { errorMessage }) {
      state.authStatus = AuthState.AUTHENTICATION_FAILURE;
      state.signupErrorMessage = `*${errorMessage}`;
    },
    [RESET_EMAIL_INPUT_PENDING](state) {
      state.passwordResetStatus = PasswordResetRequestState.EMAIL_INPUT.PENDING;
    },
    [RESET_EMAIL_INPUT_SUCCESS](state) {
      state.passwordResetStatus = PasswordResetRequestState.EMAIL_INPUT.SUCCESS;
    },
    [RESET_EMAIL_INPUT_FAILED](state) {
      state.passwordResetStatus = PasswordResetRequestState.EMAIL_INPUT.FAILED;
    },
    [TOKEN_INPUT_PENDING](state) {
      state.passwordResetStatus = PasswordResetRequestState.TOKEN_INPUT.PENDING;
    },
    [TOKEN_INPUT_SUCCESS](state) {
      state.passwordResetStatus = PasswordResetRequestState.TOKEN_INPUT.SUCCESS;
    },
    [TOKEN_INPUT_FAILED](state) {
      state.passwordResetStatus = PasswordResetRequestState.TOKEN_INPUT.FAILED;
    },
    [RESET_PASSWORD_INPUT_PENDING](state) {
      state.passwordResetStatus = PasswordResetRequestState.PASSWORD_INPUT.PENDING;
    },
    [RESET_PASSWORD_INPUT_SUCCESS](state) {
      state.passwordResetStatus = PasswordResetRequestState.PASSWORD_INPUT.SUCCESS;
    },
    [RESET_PASSWORD_INPUT_FAILED](state) {
      state.passwordResetStatus = PasswordResetRequestState.PASSWORD_INPUT.FAILED;
    },
    [DISPLAY_RESET_EMAIL](state) {
      state.passwordResetDisplayStatus = PasswordResetDisplayState.EMAIL;
    },
    [DISPLAY_TOKEN](state) {
      state.passwordResetDisplayStatus = PasswordResetDisplayState.TOKEN;
    },
    [DISPLAY_RESET_PASSWORD](state) {
      state.passwordResetDisplayStatus = PasswordResetDisplayState.PASSWORD;
    },
    [LOGOUT](state) {
      state.authStatus = AuthState.UNAUTHENTICATED;
      state.user = { email: "", dealerName: "" };
      state.token = "";
      window.localStorage.setItem("token", "");
      window.localStorage.setItem("email", "");
      window.localStorage.setItem("dealerName", "");
    },
    [SET_USER](state, { email, dealerName }) {
      state.user.email = email;
      state.user.dealerName = dealerName;
      window.localStorage.setItem("email", email);
      window.localStorage.setItem("dealerName", dealerName);
    },
    [SET_TOKEN](state, token) {
      state.token = token;
      window.localStorage.setItem("token", token);
    },
    [RESET_APP](state) {
      state.authStatus = AuthState.UNAUTHENTICATED;
      state.passwordResetStatus = PasswordResetRequestState.EMAIL_INPUT.RESET_EMAIL_INPUT_FAILED;
      state.passwordResetDisplayStatus = PasswordResetDisplayState.EMAIL;
      state.loginErrorMessage = "";
      state.signupErrorMessage = "";
      state.token = "";
      state.resetToken = "";
      state.user = {
        email: "",
        dealerName: ""
      };
    }
  },
  actions: {
    async checkAuthenticated({ state, commit }) {
      if (state.token != "" && state.token != null) {
        return validateLoginToken(state.token)
          .then(res => {
            if (res.data.success) {
              commit(LOGIN_REQUEST_SUCCESS);
              console.log("successfully validate login token");
            }
          })
          .catch(() => {
            console.log("failed to validate login token");
            commit(LOGOUT);
          });
      }
    },
    login({ state, commit }, { email, password }) {
      if (state.authStatus == AuthState.AUTHENTICATED) return;
      if (!email || !password) return;
      commit(LOGIN_REQUEST_PENDING);
      return sendLoginRequest(email, password)
        .then(res => {
          console.log(res);
          if (res.data.success) {
            commit(LOGIN_REQUEST_SUCCESS);
            commit(SET_USER, { email: res.data.email, dealerName: res.data.dealerName });
            commit(SET_TOKEN, res.data.token);
          } else {
            commit(LOGIN_REQUEST_FAILED, { errorMessage: res.data.error });
          }
        })
        .catch(res => {
          console.log(res);
          commit(LOGIN_REQUEST_FAILED, { errorMessage: res || "failed to connect.." });
        });
    },
    signup({ state, commit }, { dealerNumber, email, password }) {
      if (state.authStatus == AuthState.AUTHENTICATED) return;
      if (!dealerNumber || !email || !password) return;
      return sendSignupRequest(dealerNumber, email, password)
        .then(res => {
          if (res.data.success) {
            commit(SIGNUP_REQUEST_SUCCESS);
            commit(SET_USER, { email: res.data.email, dealerName: res.data.dealerName });
            commit(SET_TOKEN, res.data.token);
          } else {
            commit(SIGNUP_REQUEST_FAILED, { errorMessage: res.data.error });
          }
        })
        .catch(res => {
          console.log(res);
          commit(SIGNUP_REQUEST_FAILED, { errorMessage: "could not connect.." });
        });
    },
    requestToken({ state, commit }, { email }) {
      if (state.authStatus == AuthState.AUTHENTICATED) return;
      if (!email) return;
      state.user.email = email;
      commit(RESET_EMAIL_INPUT_PENDING);
      return sendTokenRequest(email)
        .then(res => {
          commit(RESET_EMAIL_INPUT_SUCCESS);
          commit(DISPLAY_TOKEN);
        })
        .catch(res => {
          commit(RESET_EMAIL_INPUT_FAILED);
        });
    },
    validateToken({ state, commit }, { token }) {
      if (state.authStatus == AuthState.AUTHENTICATED) return;
      if (!state.user.email || !token) return;
      state.resetToken = token;
      commit(TOKEN_INPUT_PENDING);
      return sendTokenValidationRequest(token, state.user.email)
        .then(res => {
          commit(TOKEN_INPUT_SUCCESS);
          commit(DISPLAY_RESET_PASSWORD);
        })
        .catch(res => {
          commit(TOKEN_INPUT_FAILED);
        });
    },
    requestNewPassword({ state, commit }, { password }) {
      if (state.authStatus == AuthState.AUTHENTICATED) return;
      if (!state.user.email || !state.resetToken) return;
      commit(RESET_PASSWORD_INPUT_PENDING);
      return sendNewPasswordRequest(state.resetToken, state.user.email, password)
        .then(res => {
          commit(RESET_PASSWORD_INPUT_SUCCESS);
          commit(DISPLAY_RESET_EMAIL); //just reset
        })
        .catch(res => {
          commit(RESET_PASSWORD_INPUT_FAILED);
        });
    },
    logout({ state, commit }) {
      if (state.authStatus == AuthState.UNAUTHENTICATED) return;
      commit(LOGOUT);
    }
  },
  getters: {}
};
